import React from 'react';
import PropTypes from 'prop-types';
import DoubleCounterContainer from 'components/shared/counters/double/DoubleCounterContainer';
import CounterSection from 'components/shared/counters/CounterSection';

function DoubleCounter({ counters, emoji, onClick = null, title, type = 'number' }) {
  return (
    <DoubleCounterContainer title={title} emoji={emoji} onClick={onClick}>
      <CounterSection counter={counters[0].counter} title={counters[0].title} type={type} />
      <CounterSection counter={counters[1].counter} title={counters[1].title} type={type} />
    </DoubleCounterContainer>
  );
}

DoubleCounter.propTypes = {
  counters: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      counter: PropTypes.number.isRequired
    })
  ).isRequired,
  emoji: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['number', 'currency'])
};

export default DoubleCounter;
